import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ActivitiesPage = lazy(() => import('../pages/activities/page'));
const GetInvolvedPage = lazy(() => import('../pages/get-involved/page'));
const NewsPage = lazy(() => import('../pages/news/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const DonatePage = lazy(() => import('../pages/donate/page'));
const GalleryPage = lazy(() => import('../pages/gallery/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const CareersPage = lazy(() => import('../pages/careers/page'));
const PartnersPage = lazy(() => import('../pages/partners/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const SuccessPage = lazy(() => import('../pages/success/page'));
const CancelPage = lazy(() => import('../pages/cancel/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/activities',
    element: <ActivitiesPage />,
  },
  {
    path: '/news',
    element: <NewsPage />,
  },
  {
    path: '/careers',
    element: <CareersPage />,
  },
  {
    path: '/partners',
    element: <PartnersPage />,
  },
  {
    path: '/get-involved',
    element: <GetInvolvedPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/donate',
    element: <DonatePage />,
  },
  {
    path: '/gallery',
    element: <GalleryPage />,
  },
  {
    path: '/faq',
    element: <FAQPage />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '/success',
    element: <SuccessPage />,
  },
  {
    path: '/cancel',
    element: <CancelPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
